import { render, staticRenderFns } from "./add-tag.vue?vue&type=template&id=984ba654&scoped=true&"
import script from "./add-tag.vue?vue&type=script&lang=js&"
export * from "./add-tag.vue?vue&type=script&lang=js&"
import style0 from "./add-tag.vue?vue&type=style&index=0&id=984ba654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984ba654",
  null
  
)

export default component.exports